import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M7.7377 9.705H5.70597C4.76394 9.705 4 10.4336 4 11.331V20.374C4 21.2721 4.76365 22 5.70597 22H18.294C19.2363 22 20 21.2721 20 20.374V11.331C20 10.4336 19.2361 9.705 18.294 9.705H16.2623V6.062C16.2623 3.81886 14.354 2 12.0005 2C9.6462 2 7.7377 3.81868 7.7377 6.062V9.705ZM8.78689 9.705H15.2131V6.062C15.2131 4.37114 13.7745 3 12.0005 3C10.2256 3 8.78689 4.37101 8.78689 6.062V9.705ZM15.7377 10.705H8.2623H5.70597C5.34353 10.705 5.04918 10.9857 5.04918 11.331V20.374C5.04918 20.7199 5.3431 21 5.70597 21H18.294C18.6569 21 18.9508 20.7199 18.9508 20.374V11.331C18.9508 10.9857 18.6565 10.705 18.294 10.705H15.7377ZM9.25456 15.4987C9.0497 15.3035 8.71754 15.3035 8.51268 15.4987C8.30781 15.694 8.30781 16.0106 8.51268 16.2059L10.7789 18.3659C10.9935 18.5704 11.3448 18.5592 11.5446 18.3416L15.5115 14.0216C15.7024 13.8138 15.6803 13.4979 15.4623 13.3161C15.2443 13.1342 14.9129 13.1552 14.7221 13.363L11.1243 17.2809L9.25456 15.4987Z" />
    </svg>
  );
}